export const ribbonCustomize = "p9IGdc";
export default {ribbonCustomize};